import React, { useRef, useState } from 'react';
// @ts-ignore
import { useAppContext } from '../../Services/AppContext';
// @ts-ignore
import moment from 'moment';
import WorkplaceCalendarModal from './WorkplaceCalendarModal';
import Text from '../Base/Text/Text';
import { joinClasses } from '../../Utils/className.util';

interface IOrderPatientButton {
	patientId: string;
	workplaceId: string;
	className?: string;
	caseId?: string;
}

export default function OrderPatientButton(props: IOrderPatientButton) {
	const { patientId, workplaceId, caseId, className } = props;
	const [modalOpen, setModalOpen] = useState(false);

	const handleOpenModal = () => {
		setModalOpen(true);
	};

	return (
		<>
			<button
				className={joinClasses(['btn-link blue text-underline', className])}
				onClick={handleOpenModal}>
				<Text tx={'base.shared.orderAPatient'} inline firstUpper />
			</button>
			<WorkplaceCalendarModal
				opened={modalOpen}
				onClose={() => setModalOpen(false)}
				patientId={patientId}
				workplaceId={workplaceId}
				caseId={caseId}
			/>
		</>
	);
}
